import { getResourceCalendarBoldDate, getResourceCalendarSchedule } from "../services/resourceCalendarService";
import { IGetResourceCalendarRequest, ResourceCalendarInfo } from "../services/types/resourceCalendarEntity";

export const useResourceCalendar = () => {
  const getResourceCalendarBoldDateFromServer = async (request: IGetResourceCalendarRequest): Promise<Date[]> => {
    const response = await getResourceCalendarBoldDate(request);
    return response.data?.map((date) => new Date(date)) || [];
  };

  const getResourceCalendarScheduleFromServer = async (request: IGetResourceCalendarRequest): Promise<ResourceCalendarInfo[]> => {
    const response = await getResourceCalendarSchedule(request);
    return response.data || [];
  };

  return { getResourceCalendarBoldDateFromServer, getResourceCalendarScheduleFromServer };
};
